import { getConversationAssignee } from 'actions/conversation/lib/conversation_helpers';
import getAssigneeDetails from 'components/lib/assignment_menu/lib/get_assignee_details';

/**
 * Resolves assignee state for a conversation: the conversation-level assignee and
 * the customer-level assignee (dedicated hero / hero inbox) from the assignee store.
 *
 * Note: customerAssignee is always resolved when present in the store. The dedicated hero
 * feature gate (canManageCustomerAssignee) controls UI visibility, not data resolution.
 */
export default function getAssigneeStateForConversation({ getProvider, isFeatureEnabled }, conversationId) {
  // Always touch `conversations` so connect observes that provider (even when conversationId is missing).
  const conversations = getProvider('conversations');
  const conversation = conversationId ? conversations.findBy({ id: conversationId }) : null;
  const convAssignee = conversation ? getConversationAssignee(conversation) : {};
  const conversationAssignee = getAssigneeDetails(
    { getProvider, isFeatureEnabled },
    {
      agentId: convAssignee.agentId,
      groupId: convAssignee.groupId,
    }
  );

  const custAssigneeRaw = getProvider('assignee').get() || {};
  const customerAssignee =
    custAssigneeRaw.agentId || custAssigneeRaw.routingGroupId
      ? getAssigneeDetails(
          { getProvider, isFeatureEnabled },
          { agentId: custAssigneeRaw.agentId, groupId: custAssigneeRaw.routingGroupId }
        )
      : {};

  return {
    conversationAssignee,
    customerAssignee,
  };
}
